import { useDispatch, useSelector } from 'react-redux'

// antd
import {
    Col,
    Row,
    Space,
    Tooltip,
    Typography,
    Badge,
    theme,
    Divider,
    Tag,
} from 'antd'
import { CheckOutlined, BugOutlined, ProjectOutlined } from '@ant-design/icons'

// slices
import { projectsState } from '../../projects/projects.slice'
import { switchFormModal, supportTaskById } from './support.slice'

// styles
import styles from '../tasks.module.css'

// helpers
import { estimateFn } from '../../../helpers/estimationCalculation'
import { priorityType } from '../../../constants/tasks.index'

const TaskBoard = ({ props }) => {
    const { tasks, spread } = props

    const { Text } = Typography

    const { useToken } = theme
    const { token } = useToken()

    const dispatch = useDispatch()

    const { currentProjectData } = useSelector(projectsState)

    // VIEW TASK
    async function viewTask(taskID) {
        dispatch(
            switchFormModal({
                open: true,
            })
        )
        dispatch(supportTaskById({ _id: taskID }))
    }

    const Card = ({ props }) => {
        const { card } = props
        const { _id, title, type } = card

        return (
            <div
                className={styles.card}
                onClick={(e) => {
                    const shouldIgnore =
                        e.target.closest('[data-ignore-click]') ||
                        e.target.closest('.ignore-view-task') ||
                        e.target.closest('.ant-avatar-string') ||
                        e.target.closest('.ant-image') ||
                        e.target.tagName === 'svg' ||
                        e.target.tagName === 'path'

                    if (!shouldIgnore) {
                        viewTask(_id)
                    }
                }}
                style={{
                    cursor: 'pointer',
                }}
            >
                <Row justify={'space-between'} align={'middle'}>
                    <Row
                        align={'middle'}
                        style={{
                            columnGap: '10px',
                        }}
                    >
                        <Tooltip title={`Priority`} arrow={false}>
                            <div
                                style={{
                                    cursor: 'auto',
                                }}
                            >
                                <Tag
                                    color={
                                        priorityType.find(
                                            (p) => p?.value === card?.priority
                                        )?.color
                                    }
                                    style={{
                                        borderRadius: '5px',
                                        fontWeight: 500,
                                        padding: '2px 10px',
                                        margin: 0,
                                    }}
                                >
                                    {card?.priority}
                                </Tag>
                            </div>
                        </Tooltip>
                    </Row>
                </Row>
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                    }}
                >
                    <Text>{title}</Text>
                </div>
                <Row justify={'space-between'} align={'middle'}>
                    <Col>
                        <Row align={'middle'}>
                            <Space size={'small'}>
                                <Tooltip title={type} arrow={false}>
                                    {type === 'Bug' ? (
                                        <div
                                            className={styles.taskTypeSection}
                                            style={{
                                                backgroundColor: 'red',
                                            }}
                                        >
                                            <BugOutlined
                                                style={{
                                                    fontSize: '12px',
                                                    color: 'white',
                                                }}
                                            />
                                        </div>
                                    ) : type === 'Task' ? (
                                        <div
                                            className={styles.taskTypeSection}
                                            style={{
                                                backgroundColor:
                                                    token.colorPalette.baseColor
                                                        .tertiary,
                                            }}
                                        >
                                            <CheckOutlined
                                                style={{
                                                    fontSize: '10px',
                                                    color: 'white',
                                                }}
                                            />
                                        </div>
                                    ) : (
                                        <div
                                            className={styles.taskTypeSection}
                                            style={{
                                                backgroundColor: '#7a16ff',
                                            }}
                                        >
                                            <ProjectOutlined
                                                style={{
                                                    fontSize: '10px',
                                                    color: 'white',
                                                }}
                                            />
                                        </div>
                                    )}
                                </Tooltip>

                                <Text className={styles.keyText}>
                                    {card?.taskKey}
                                </Text>
                            </Space>
                        </Row>
                    </Col>
                    <Row align={'middle'}>
                        <Space size={'small'}>
                            <Tooltip
                                arrow={false}
                                title={
                                    card?.estimation !== 0
                                        ? estimateFn(
                                              card?.estimation,
                                              currentProjectData
                                          )
                                        : 'Unestimated'
                                }
                            >
                                <Badge
                                    count={
                                        card?.estimation !== 0
                                            ? estimateFn(
                                                  card?.estimation,
                                                  currentProjectData
                                              )
                                            : '-'
                                    }
                                    color="#85BBF9"
                                    style={{
                                        minWidth: '30px',
                                        cursor: 'auto',
                                    }}
                                />
                            </Tooltip>
                            {card?.assigneeId?.[0] && (
                                <div
                                    style={{
                                        cursor: 'default',
                                        pointerEvents: 'none',
                                    }}
                                    data-ignore-click
                                    className="ignore-view-task"
                                    onClick={(e) => {
                                        e.stopPropagation()
                                        e.preventDefault()
                                    }}
                                    onMouseDown={(e) => {
                                        e.stopPropagation()
                                        e.preventDefault()
                                    }}
                                >
                                    <Tooltip
                                        title={card?.assigneeId[0]?.name}
                                        arrow={false}
                                        trigger="hover"
                                    >
                                        <div
                                            style={{
                                                width: 32,
                                                height: 32,
                                                borderRadius: '50%',
                                                backgroundColor:
                                                    token.colorPalette.baseColor
                                                        .tertiary,
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                color: 'white',
                                                fontSize: '12px',
                                                fontWeight: 500,
                                                pointerEvents: 'auto',
                                            }}
                                        >
                                            {card?.assigneeId[0]
                                                ?.profilePicture ? (
                                                <img
                                                    src={
                                                        card?.assigneeId[0]
                                                            ?.profilePicture
                                                    }
                                                    alt={
                                                        card?.assigneeId[0]
                                                            ?.name
                                                    }
                                                    style={{
                                                        width: '100%',
                                                        height: '100%',
                                                        borderRadius: '50%',
                                                        objectFit: 'cover',
                                                        pointerEvents: 'none',
                                                    }}
                                                />
                                            ) : (
                                                card?.assigneeId[0]?.name
                                                    ?.charAt(0)
                                                    ?.toUpperCase()
                                            )}
                                        </div>
                                    </Tooltip>
                                </div>
                            )}
                        </Space>
                    </Row>
                </Row>
            </div>
        )
    }

    const Column = ({ props }) => {
        const { column } = props

        const { list, _id } = column

        let countTask = list.filter((item) => item !== null)

        return (
            <Col
                xs={12}
                sm={12}
                md={12}
                lg={10}
                xl={8}
                xxl={6}
                style={{
                    height: 'max-content',
                }}
            >
                <Row
                    align={'middle'}
                    justify={'space-between'}
                    style={{
                        padding: '16px',
                        borderTopLeftRadius: 12,
                        borderTopRightRadius: 12,
                        backgroundColor:
                            token.colorPalette.baseColor.quaternary,
                    }}
                >
                    <div
                        className={'sub-title'}
                        style={{
                            padding: '4px 12px',
                            borderRadius: 1000,
                        }}
                    >
                        <span style={{ fontWeight: 600 }}>{_id}</span>{' '}
                        <span
                            style={{
                                color: '#888',
                                fontWeight: 'normal',
                                marginLeft: '8px',
                            }}
                        >
                            {countTask?.length || 0}
                        </span>
                    </div>

                    <Divider
                        style={{
                            marginBottom: '0px',
                        }}
                    />
                </Row>
                <div
                    className={styles.column}
                    style={{
                        maxHeight: `${window.innerHeight - 400}px`,
                        overflowY: 'scroll',
                        scrollbarColor: '#888 #f7f5ff',
                        scrollbarWidth: 'thin',
                    }}
                >
                    {list?.length > 0 &&
                        list.map(
                            (card, index) =>
                                card?.parentTask?.length === 0 && (
                                    <Card key={index} props={{ card }} />
                                )
                        )}
                </div>
            </Col>
        )
    }

    return (
        <div
            className={'sub-container'}
            style={{
                overflowX: 'scroll',
                height: spread ? 'max-content' : 'calc(100vh - 140px)',
            }}
        >
            <Row wrap={false} gutter={14}>
                {tasks?.map((column, index) => (
                    <Column key={index} props={{ column }} />
                ))}
            </Row>
        </div>
    )
}

export default TaskBoard
